import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { TransactionHistoryCompact } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/TransactionHistoryCompact';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const shortCodes = ['transactions-history'] as const;

type Props = {
  code: (typeof shortCodes)[number];
};

const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  position: relative;
  isolation: isolate;
  padding: var(--double-unit);
  border: 1px solid var(--c-nd-100);
`;

const Title = styled(LabelS).attrs({ bold: true })`
  position: absolute;
  top: 0;
  right: 0;
  background: var(--c-nd-100);
  color: var(--c-white);
  padding: var(--half-unit) var(--unit) var(--half-unit)
    var(--intermediate-unit);
  border-bottom-left-radius: var(--unit);
`;

const Content = styled.div``;

const titles = defineMessages({
  'transactions-history': {
    id: 'ShortCode.TransactionsHistory.latestTransactions',
    defaultMessage: 'Latest transactions',
  },
});

const signIns = defineMessages({
  'transactions-history': {
    id: 'ShortCode.TransactionsHistory.signIn',
    defaultMessage: 'Sign in to view your transactions',
  },
});

export const Shortcode = ({ code }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const signInAndStay = useLoggedCallback(() => {});

  return (
    <Wrapper>
      <Content>
        {currentUser ? (
          <>
            {code === 'transactions-history' && <TransactionHistoryCompact />}
          </>
        ) : (
          <Horizontal center>
            <Button onClick={signInAndStay} size="medium">
              <FormattedMessage {...signIns[code]} />
            </Button>
          </Horizontal>
        )}
      </Content>
      <Title>
        <FormattedMessage {...titles[code]} />
      </Title>
    </Wrapper>
  );
};
